import { render, staticRenderFns } from "./MonthlyPlans.vue?vue&type=template&id=219baa86"
import script from "./MonthlyPlans.vue?vue&type=script&lang=js"
export * from "./MonthlyPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports